async function addToCart(product) {
	return await ajax('cartAdd', { product }, res => {
		gtmEvent('add_to_cart', ga4Cart(... res.items));
	});
}

async function removeFromCart(product) {
	return await ajax('cartRemove', { product }, res => {
		gtmEvent('remove_from_cart', ga4Cart(... res.items));
	});
}

async function emptyCart() {
	return await ajax('cartEmpty', {}, res => {
		gtmEvent('remove_from_cart', ga4Cart(... res.items));
	});
}

function refreshCart({ cart, output }, products, cartBar) {
	for (const product of products) {
		const exists = cart.includes(product.dataset.product);

		product.classList.toggle('products-product-added', exists);
		product.classList.toggle('splash-card-accent', exists);
	}

	const cartPrices = Array.from(document.getElementsByClassName('cart-total-price'));

	for (const el of cartPrices) {
		el.textContent = output.price;
	}

	const carts = Array.from(document.getElementsByClassName('cart-products'));

	for (const el of carts) {
		el.replaceChildren([]);
		el.insertAdjacentHTML('afterbegin', output.html);
	}

	cartBar.classList.toggle('products-cart-bar-in', cart.length > 0);
}

export default function() {
	const products = [
		... document.getElementsByClassName('products-product'),
	];

	const cartBar = document.getElementById('products-cart-bar');

	for (const product of products) {
		const addButton = product.querySelector('.products-cart-add');

		addButton ? addButton.addEventListener('click', async e => {
			e.preventDefault();

			const cart = await addToCart(product.dataset.product);

			refreshCart(cart, products, cartBar);
		}) : null;

		const removeButton = product.querySelector('.products-cart-remove');

		removeButton ? removeButton.addEventListener('click', async e => {
			e.preventDefault();

			const cart = await removeFromCart(product.dataset.product);

			refreshCart(cart, products, cartBar);
		}) : null;
	}

	document.getElementById('products-empty-cart').addEventListener('click', async e => {
		e.preventDefault();
		const cart = await emptyCart();

		refreshCart(cart, products, cartBar);
	});
}
